var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-list-item" }, [
    _c("div", { staticClass: "inner-event-wrapper" }, [
      _c(
        "div",
        { staticClass: "details" },
        [
          _c(
            "router-link",
            {
              attrs: {
                to: { name: "eventDetails", params: { slug: _vm.event.slug } }
              }
            },
            [
              _c("p", { staticClass: "title heading-3" }, [
                _vm._v(_vm._s(_vm.event.name))
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "detail-list" }, [
            _c("p", { staticClass: "line-item" }, [
              _c("strong", [_vm._v("Date:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.parsedStartDate))]),
              _vm._v(" "),
              _vm.parsedEndDate !== "" &&
              _vm.parsedEndDate != _vm.parsedStartDate
                ? _c("span", [_vm._v(" to ")])
                : _vm._e(),
              _vm._v(" "),
              _vm.parsedEndDate !== "" &&
              _vm.parsedEndDate != _vm.parsedStartDate
                ? _c("span", [_vm._v(_vm._s(_vm.parsedEndDate))])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "line-item" }, [
              _c("strong", [_vm._v("Time:")]),
              _vm._v(" " + _vm._s(_vm.event.startTime) + " "),
              _vm.event.endTime !== ""
                ? _c("span", [_vm._v(" to " + _vm._s(_vm.event.endTime))])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "line-item" }, [
              _c("strong", [_vm._v("Location:")]),
              _vm._v(" " + _vm._s(_vm.event.eventStoreLocation))
            ])
          ]),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "event-detail-button",
              attrs: {
                to: { name: "eventDetails", params: { slug: _vm.event.slug } }
              }
            },
            [
              _c("a", { staticClass: "btn", attrs: { href: "" } }, [
                _vm._v("More Info")
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "image" },
        [
          _c(
            "router-link",
            {
              attrs: {
                to: { name: "eventDetails", params: { slug: _vm.event.slug } }
              }
            },
            [
              _vm.event.image && _vm.event.image !== ""
                ? _c("div", {
                    staticClass: "event-image",
                    style: {
                      "background-image": "url(" + _vm.event.image + ")"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.event.image === ""
                ? _c("div", { staticClass: "inner-background-default" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://cdn.shopify.com/s/files/1/0330/3299/4860/files/background_logo.png?v=1584731378",
                        alt: "Snow Peak Event"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("Snow Peak Event")])
                  ])
                : _vm._e()
            ]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div")
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }